import { api } from 'agent';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';

// Generic person autocomplete — returns all active CERN persons matching the
// name fragment (no HSE filter, no competency filter). Used by free-form
// resolver pickers like the action form.
export function getPersonAutocomplete(name: string): Promise<PersonDTO[]> {
  return api
    .get('/persons/autocomplete', false, { name })
    .then((response: { data: PersonDTO[] }) => response.data);
}
